import { auth, db } from "../firebaseConfig";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { signOut } from "firebase/auth";
import { IoIosClose } from "react-icons/io";
import { IoMenuSharp } from "react-icons/io5";
import MaranaAZLogoWhite from "../assets/MaranaAZLogoWhite.png";

function Sidebar() {
  const [userRole, setUserRole] = useState(null);
  const user = auth.currentUser;
  const [sidebarMenu, setSidebarMenu] = useState(false);

  useEffect(() => {
    const fetchUserRole = async () => {
        if (user) {
            try {
                const userRef = doc(db, "users", user.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    setUserRole(userSnap.data().role || "No role assigned");
                } 
          
                else {
                    //console.log("No user document found");
                    setUserRole("Unknown");
                }
            } 
            
            catch (error) {
                console.error("Error fetching user role:", error);
                setUserRole("Error");
            } 
            
      } 
    };

    fetchUserRole();
  }, [user]);

    const email = user.email;

    return (
        <>
          {sidebarMenu ? (
            <div className="sidebar">
              <IoIosClose className="sidebar-close-icon" onClick={() => setSidebarMenu(false)}/>
              <img src={MaranaAZLogoWhite} alt="Marana AZ Logo" style={{width: "100%", marginLeft: "auto", marginRight: "auto"}}/>
              <hr />
              <p>Email: {email}</p>
              <p>Role: {userRole}</p>

              <hr id="signout-hr"></hr>
              <div className="signout-button-div">
                <Link className="link-btn" to="/"><button className="signout-button" title="Sign-out" onClick={() => signOut(auth)}>Sign Out</button></Link>
              </div>
              
            </div>
          ) : (
            <div className="sidebar-collapsed">
              <IoMenuSharp onClick={() => setSidebarMenu(true)}/>
            </div>
          )}
        </>
      );
}

export default Sidebar;